module.exports = __webpack_public_path__ + "static/img/check_nouse.725a02b3.png";